import {
  TabContainer,
  ThankyouHeader,
  ThankyouMessage,
} from "../../components/SocialCaseTbas/Social.styled";
import thanks from "../../assets/thanks.svg";
import ErrorIcon from "../../assets/error-icon.svg";

import { ButtonContainer, ButtonSecondary } from "../../screens/login.screen/login.styled";
import { useEffect, useState } from "react";
import User from "../../stores/UserStore";
import AccountsNotifications from "../../stores/AccountsNotificationsStore";

import General from "../../stores/GeneralStore";
import { Link, useNavigate } from "react-router-dom";
import { observer } from "mobx-react";
import { toJS } from "mobx";
import HappyMeterStore from "../../stores/HappyMeter";
import { Spinner, SpinnerRaw } from "../../components/SpinnerRaw/SpinnerRaw";
import { NotifyError } from "../../utils/ShowError";

const ExternalPaymentResult = () => {
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(window.location.search);
  const type: any = searchParams?.get("type");
  const sessionId: any = searchParams?.get("ref");
  const paymentId: any = searchParams.get("payment_id");
  const [success, setSuccess] = useState<any>(false);
  const [loader, setLoader] = useState<any>(true);
  const [email, setEmail] = useState<any>();

  // const externalPayment3DS = async (sessionId: string, type: any) => {
  //   const data = {
  //     sessionId,
  //     type, 
  //   };

  //   try {
  //     const res = await General.externalPayment3DS({ errorId: "updatePayment", data });
  //     console.log("API Response:", res);
  //     if (!General?.paymentUpdateResponse.isError) {
  //       setSuccess(true);
  //       setLoader(false);
  //       HappyMeterStore.setUpTranctionId(General?.paymentUpdateResponse?.result?.orderId)
  //       HappyMeterStore.setUPserviceID(type)
  //       // if(!redirectFromPayment)
  //       if (type != "7") {
  //         HappyMeterStore.openHappinessMeter()
  //       }

  //     } else {
  //       setSuccess(false);
  //       setLoader(false);
  //       // localStorage.removeItem('payment_moveIn');
  //     }
  //   } catch (error) {
  //     setSuccess(false);
  //     setLoader(false);
  //   }
  // };


   const externalPayment3DS = async (sessionId: string, type: any) => {
    const data = { sessionId, type };

    try {
      const res = await General.externalPayment3DS({
        errorId: "updatePayment",
        data,
      });
      console.log("NI API Response:", res);
      if (!General?.paymentUpdateResponse.isError) {
        handleSuccess(type);
      } else {
        handleFailure();
      }
    } catch (error) {
      handleFailure();
    }
  };

  const TabbyPayment3DS = async (paymentId: string, type: any) => {
    const data = { sessionId:paymentId, type };

    try {
      const res = await General.TabbyPayment3DS({
        errorId: "updateTabbyPayment",
        data,
      });
      console.log("Tabby API Response:", res);
      if (!General?.paymentUpdateResponse.isError) {
        handleSuccess(type);
      } else {
        handleFailure();
      }
    } catch (error) {
      handleFailure();
    }
  };
  const TamaraPayment3DS = async (orderId: string, type: any) => {
    const data = { sessionId:orderId, type };

    try {
      const res = await General.TamaraPayment3DS({
        errorId: "updateTabbyPayment",
        data,
      });
      console.log("Tabby API Response:", res);
      if (!General?.paymentUpdateResponse.isError) {
        handleSuccess(type);
      } else {
        handleFailure();
      }
    } catch (error) {
      handleFailure();
    }
  };

  const handleSuccess = (type: any) => {
    setSuccess(true);
    setLoader(false);
    HappyMeterStore.setUpTranctionId(
      General?.paymentUpdateResponse?.result?.orderId
    );
    if(type === "4")
    {
      HappyMeterStore.setUPserviceID("8");//bill payment
    }
    else if(type === "3")
    {
      HappyMeterStore.setUPserviceID("6");//Moveout payment and normal moveout application
    }
    else{
     HappyMeterStore.setUPserviceID(type);
}

    if (type != "7") {
      HappyMeterStore.openHappinessMeter();
    }
  };

  const handleFailure = () => {
    setSuccess(false);
    setLoader(false);
  };

  const handleNavigate = () => {
    if (success) {
      if (type == "5") {
          navigate("/movein-registration", {
            state: {
              id: General?.paymentUpdateResponse?.result?.orderId,
            },
          });
        // const redirectFromPayment = localStorage.getItem('MoveInPayment');
        // if (redirectFromPayment) {
        //   navigate("/movein-registration", {
        //     state: {
        //       id: General?.paymentUpdateResponse?.result?.orderId,
        //     },
        //   });
        // } else {
        //   // HappyMeterStore.openHappinessMeter()comment due to immediately open
        // }

      } else if (type == "3") {
        navigate("/dashboard");
      } else if (type == "7") {
        navigate("/dashboard", { state: { paymentPlan: true } });
      } else if (type == "6") {
        navigate("/dashboard", { state: { autoPay: true, sourceId: General?.paymentUpdateResponse?.result?.previousPaymentId } });
      }
      else {
        // HappyMeterStore.openHappinessMeter()comment due to immediately show popup
        // navigate("/");
        if (User?.profile?.personId) {
          navigate("/dashboard");
        } else {
          navigate('/');
        }

      }
    } else {

      navigate("/dashboard");

    }
  };
  const [downloadLoader, setDownloadLoader] = useState(false);
  const downloadBillPDF = async () => {
    try {
      setDownloadLoader(true);
      const data = { id: `${General?.paymentUpdateResponse?.result?.id}`,orderId: `${General?.paymentUpdateResponse?.result?.orderId}`};
      const res: any = await AccountsNotifications?.downloadNOCAndMoveout(data);
      setTimeout(() => { setDownloadLoader(false) }, 5000)
      if (!res) {
        setDownloadLoader(false)
        // NotifyError(General?.codeLabels['cm_servererror']?.label)
      }
    } catch (error) {
      setDownloadLoader(false)
      NotifyError(General?.codeLabels['cm_servererror']?.label)
    }


  };
  useEffect(() => {
    const paymentId = searchParams.get("payment_id");
  const niRef = searchParams.get("ref");
  const orderId = searchParams.get("orderId");
  const type = searchParams.get("type");
    if (paymentId) {
      TabbyPayment3DS(paymentId, type);
    } else if (niRef) {
      externalPayment3DS(niRef, type);
    } else if (orderId) {
      TamaraPayment3DS(orderId, type);
    }
  }, []);
  const updatedText = () => {
    console.log("Payment Update Response:", General.paymentUpdateResponse);
    console.log("##:", General.paymentUpdateResponse?.result);

    var paymentId = type == '4' || type == '7' || type == "5" ? General?.paymentUpdateResponse?.result?.paymentId : General?.paymentUpdateResponse?.result?.orderId
    const originalText = General?.codeLabels[General?.paymentUpdateResponse?.result?.message?.toLowerCase()]?.label;
    var email = ''
    var nocReference = ''
    var updatedTextMsg;
    if (type == '2' || type == "3") {
      email = General?.paymentUpdateResponse?.result?.email ? General?.paymentUpdateResponse?.result?.email : ""
      nocReference = General?.paymentUpdateResponse?.result?.paymentReference ? General?.paymentUpdateResponse?.result?.paymentReference :""
      updatedTextMsg = originalText?.replace('{0}', paymentId)?.replace('{1}', email)?.replace('<br />', nocReference);
      return updatedTextMsg;

    } else {
      if (originalText?.includes("<br />") && originalText?.includes("{0}")) {
        updatedTextMsg = originalText?.replace('{0}', paymentId);
        return updatedTextMsg;
      }
      if (originalText?.includes("{0}")) {
        updatedTextMsg = originalText?.replace('{0}', paymentId);
        return updatedTextMsg;
      }
      if (originalText?.includes("<br />")) {
        updatedTextMsg = originalText;
        return updatedTextMsg;
      }
      else {
        updatedTextMsg = originalText;
        return updatedTextMsg;
      }
    }
  }
  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;

  return (
    <>
      {loader ? (
        <div
          style={{
            width: "100vw",
            display: "flex",
            justifyContent: "center",
            height: "70vh",
            alignItems: "center",
            background: "#eeeeee",
          }}
        >
          <Spinner />
        </div>
      ) : (
        <div style={{ display: 'flex', width: "100%", justifyContent: "center" ,background: "#eeeeee",}}>
        <div
          style={{
            width: General?.isLargeScreen ? "100%" : "100%",
            display: "flex",
            // flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-start",
            alignSelf: "flex-start",
  
            background: "#eeeeee",
          }}
        >
         <div style={{width:'90%',marginTop:General?.isLargeScreen?'2.5rem':'8.5rem',background:'white'}}>
         <ThankyouHeader
            style={{
              background: contrast?.contrastBackground
                ? contrast?.contrastBackground
                : success
                  ? "#e0eedc"
                  : "#ffe9d9",
          
              alignSelf: "center",
            }}
          >
            <img src={success ? thanks : ErrorIcon} alt="" />
            <h1
              style={{
                margin: "0", marginBottom: "13px", fontFamily: 'Segoe UI',
                fontStyle: "normal",
                fontWeight: "400",
                fontSize: `${2.125 * General.accessibility.fontSize}rem`,
                lineHeight: "130%",
                color: General.contrast.contrastBackground
                ? General.contrast.contrastColor
                : General?.ColorAss,
              }}
            >
              {success
                ? General?.codeLabels["cm_thankyou"]?.label !== undefined
                  ? General?.codeLabels["cm_thankyou"]?.label
                  : "Thank You"
                : "Oops!"}
            </h1>
          </ThankyouHeader>
          <ThankyouMessage
            style={{
              width: General?.isLargeScreen ? "100%" : "50%",
              background: contrast?.contrastColor ? contrast?.contrastBackground : "#fff",
            }}
          >
            <p
              style={{
                padding: "0",
                margin: "0",
                marginTop: "20px",
                marginBottom: "20px",
                fontSize: `${General.accessibility.fontSize}rem`,
                fontWeight: "700",
                color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
                textAlign: "center",
              }}
              dangerouslySetInnerHTML={{
                __html: type != "6"
                  ? success
                    ? General?.codeLabels["cm_paysucc"]?.label
                    : type === "3" ? General?.codeLabels["cm_mofailed1"]?.label : General?.codeLabels["cm_payment_fail"]?.label
                  : success
                    ? General?.codeLabels["cm_card_success"]?.label
                    : General?.codeLabels["cm_card_fail"]?.label
              }}
            >
            </p>
            <p
              style={{
              padding: "0",
              margin: "0",
              marginTop: "20px",
              marginBottom: "2.5rem",
              fontSize: `${General.accessibility.fontSize}rem`,
              color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
              width: "100%",
              textAlign: "center",
              whiteSpace: General?.isLargeScreen ? "nowrap" : "normal"
              }}
              dangerouslySetInnerHTML={{
              __html: success
              ? updatedText()
              : General?.paymentUpdateResponse?.errorMessage
              ? General?.codeLabels[General?.paymentUpdateResponse?.errorMessage?.toLowerCase()]?.label
              : ""
              }}
            >
              {/* {type=='3'&&!success?General?.paymentUpdateResponse?.errorMessage:null} */}
            </p>
            {success && (
              <>
                <p
                  style={{
                    fontSize: `${General.accessibility.fontSize}rem`,
                    margin: "0",
                    fontWeight: "700",
                    lineHeight: "120%",
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : ColorAss,
                      textAlign: "center",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: type == '3' ? General?.codeLabels['cm_reference']?.label : type != "6"
                      ? General?.codeLabels["cm_requestno"]?.label !== undefined
                        ? General?.codeLabels["cm_requestno"]?.label
                        : "Request Number"
                      : type == "3" ? General?.codeLabels["cm_ref"]?.label : ""
                  }}
                >
                </p>

                <h4
                  style={{
                    margin: "0",
                    fontSize: `${1.875 * General.accessibility.fontSize}rem`,
                    fontWeight: "700",
                    lineHeight: "150%",
                    marginBottom: "40px",
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : ColorAss,
                  }}
                >
                  {type == "4" || type == "7" || type == "5"
                    ? General?.paymentUpdateResponse?.result?.paymentId
                      ? General?.paymentUpdateResponse?.result?.paymentId
                      : ""
                    : General?.paymentUpdateResponse?.result?.orderId
                      ? General?.paymentUpdateResponse?.result?.orderId
                      : ""}
                </h4>
              </>
            )}
            <ButtonContainer
              style={{
                display: "flex",
                flexDirection: General?.isLargeScreen ? "row" : "column",
                justifyContent: "space-around",
              }}
            >
              <ButtonSecondary
                onClick={handleNavigate}
                style={{
                  background: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
                  color: contrast?.contrastBackground ? contrast?.contrastBackground : "#fff",
                  width: General?.isLargeScreen ? "30%" : "70%",
                  padding: "10px 10px",
                  marginBottom: "1rem",
                  fontSize: `${General.accessibility.fontSize}rem`,
                }}
              >
                {success
                  ? type == "7"
                    ? General?.codeLabels["cm_back_pdc"]?.label
                      ? General?.codeLabels["cm_back_pdc"]?.label
                      : "Back To PDC"
                    : type == "5"
                      ? General?.codeLabels["cm_back_movein"]?.label
                        ? General?.codeLabels["cm_back_movein"]?.label
                        : "Back to MoveIn Registration"
                      : General?.codeLabels["cm_back_to_dassh"]?.label
                  : General?.codeLabels["cm_back_to_dassh"]?.label}
              </ButtonSecondary>
              {General?.paymentUpdateResponse?.result?.isReadyForDownload &&
                (type == "3" || type == "2") && (
                  <ButtonSecondary
                    onClick={downloadBillPDF}
                    style={{
                      background: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
                      color: contrast?.contrastBackground ? contrast?.contrastBackground : "#fff",
                      width: General?.isLargeScreen ? "30%" : "70%",
                      padding: "10px 10px",
                      marginBottom: "1rem",
                      fontSize: `${General.accessibility.fontSize}rem`,
                    }}
                  >
                    {downloadLoader ? (
                      <SpinnerRaw width={30} height={30} />
                    ) : General?.codeLabels["cm_downloadfilepdctable"]
                      ?.label ? (
                      General?.codeLabels["cm_downloadfilepdctable"]?.label
                    ) : (
                      "Download File"
                    )}
                  </ButtonSecondary>
                )}
            </ButtonContainer>
            {/* {type == "3" && <p
              style={{
                fontSize: `${General.accessibility.fontSize}rem`,
                margin: "0",
                fontWeight: "700",
                lineHeight: "120%",
                color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
                marginBottom: "1rem",
              }}
            >
              {General?.codeLabels["cm_rfnd_tnsfr_msg"]?.label} <Link style={{ color: contrast?.contrastColor ? contrast?.contrastColor : "rgb(16, 30, 142)", }} to={'/refund'}>{General?.codeLabels['cm_clickhere']?.label}</Link>
            </p>} */}
          </ThankyouMessage>
         </div>
        </div>
        </div>
      )}
    </>
  );
};

export default observer(ExternalPaymentResult);